<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <v-dialog v-model="opened" persistent fullscreen>
    <v-container fluid class="primary py-3" style="min-height: 100%;">
      <v-row>
        <v-col cols="2">
          <v-row>
            <span class="headline" v-html="title"></span>
          </v-row>
          <v-row>
            <v-btn
              v-if="store.getters.permissionToWrite"
              class="mt-2"
              light
              :disabled="!contentValid"
              @click="saveEntity"
            >
              Save
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="8">
          <GenerateForm
            v-if="opened"
            :raw-content-types="rawContentTypes"
            :content-valid.sync="contentValid"
            :content.sync="content"
            :content-type="contentType"
          />
        </v-col>
        <v-col cols="2">
          <v-btn icon fixed top right class="my-3 mx-8" @click="close">
            <v-icon color="white" size="35">close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>
<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';

const store = useStore();

const route = useRoute();
const router = useRouter();

// eslint-disable-next-line no-undef
const props = defineProps({
  contentType: Object,
  rawContentTypes: Object,
  update: Function,
  create: Function
});

const content = ref(null);
const contentValid = ref(false);
const opened = ref(false);

const { wtype, uuid } = route.params;

const editMode = ref(true);

const title = computed(() => {
  let label = editMode.value ? 'Edit ' : 'New ';

  label += props.contentType.name;
  return label;
});

const removeVariation = () => {
  if (route.query && route.query.variation) { // remove variations
    router.replace(route.path);
  }
};

const saveEntity = () => {
  if (editMode.value) {
    props.update(content.value);
  } else {
    props.create(content.value);
  }
  opened.value = false;
  removeVariation();
};

const editItem = value => {
  editMode.value = true;
  content.value = { ...value };

  if (content.value.uuid && props.contentType.configs.hasOwnProperty('wtype')) {
    const path = { name: 'ContentEditor', params: { wtype: wtype, uuid: uuid } };

    if (content.value.uuid) { // ContentEditor with variations
      path.query = { variation: content.value.uuid };
    }

    // It opens in new tab

    if (route.query.variation !== content.value.uuid) {
      router.push(path);
    }
  }

  opened.value = true;
};

const newItem = () => {
  editMode.value = false;
  content.value = {};
  opened.value = true;
};

const close = () => {
  opened.value = false;
  removeVariation();
};

// eslint-disable-next-line no-undef
defineExpose({ editItem, newItem });

</script>
